module.exports = __webpack_public_path__ + "static/TienTran-2c06e056cbf2fcd1eb0ccff62ecdac66.svg";